/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, color, embedCorners } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PROGESSBAR STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	progressbar: {
		backgroundColor: '#555',
		extend: embedCorners,
		width: '100%',
		height: pxToEm(5),
		position: 'relative',
		marginBottom: pxToEm(7),
		'&.type-frame': {
			position: 'absolute',
			top: pxToEm(2),
			backgroundColor: color.greyDark,
			'& .progressindicator': { backgroundColor: color.greyLight }
		},
		'&.type-result': {
			backgroundColor: color.greyMedium,
			'& .progressindicator': { backgroundColor: color.brand } // brand comes from settings file from dashboard
		},
		'&.type-summary': {
			backgroundColor: color.greyDark,
			'& .progressindicator': { backgroundColor: color.greyLight }
		}
	},
	progressindicator: {
		backgroundColor: '#fff',
		borderRadius: 'inherit',
		width: '0%', // changed to 100% or 0% with a transition-duration dynamically from js component based on settings file property
		height: '100%',
		position: 'absolute',
		top: '0',
		left: '0',
		transition: 'width 0ms linear 0s', // transition-duration is inline style based on settings property showResultForXSeconds
		'&.direction-rightToLeft': {
			left: 'auto',
			right: '0'
		}
	}
};